<template>
    <div>
     <Header @refreshEnterStatus="handleRefresh" @callback="refreshByStandId" />

    <div class="banner">
        <Carousel class="index-banner">
            <CarouselItem v-for="(item,idx) in banners" :key="idx">
                <div style="height:100%; width:100%;">
                    <img :src="item.imgUrl" style="display:block;height:100%; width:100%;"  />
                </div>
            </CarouselItem>
        </Carousel>
    </div>
    <div class="main">
        <div class="wp">
            <ul class="ul-list1">
                <li>
                    <a href="#/todaysaleprice" class="con">
                        <div class="icon">
                            <img src="../assets/images/f1-icon01.png" alt="" class="img1">
                            <img src="../assets/images/f1-icon01-on.png" alt="" class="img2">
                        </div>
                        <div class="txt">
                            <h3 class="tit">今日销售价</h3>
                            <div class="desc">
                                <p>行情走势.粉丝经济.全国获客</p>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#/todayacquisitionprice" class="con">
                        <div class="icon">
                            <img src="../assets/images/f1-icon02.png" alt="" class="img1">
                            <img src="../assets/images/f1-icon02-on.png" alt="" class="img2">
                        </div>
                        <div class="txt">
                            <h3 class="tit">今日收购价</h3>
                            <div class="desc">
                                <p>行情走势.粉丝经济.全国获客</p>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#/deliver" class="con">
                        <div class="icon">
                            <img src="../assets/images/f1-icon03.png" alt="" class="img1">
                            <img src="../assets/images/f1-icon03-on.png" alt="" class="img2">
                        </div>
                        <div class="txt">
                            <h3 class="tit">铁路发货</h3>
                            <div class="desc">
                                <p>公铁联运</p>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#/freighttransport" class="con">
                        <div class="icon">
                            <img src="../assets/images/f1-icon04.png" alt="" class="img1">
                            <img src="../assets/images/f1-icon04-on.png" alt="" class="img2">
                        </div>
                        <div class="txt">
                            <h3 class="tit">公路发货</h3>
                            <div class="desc">
                                <p>找车找货</p>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#/insurance" class="con">
                        <div class="icon">
                            <img src="../assets/images/f1-icon05.png" alt="" class="img1">
                            <img src="../assets/images/f1-icon05-on.png" alt="" class="img2">
                        </div>
                        <div class="txt">
                            <h3 class="tit">保险购买</h3>
                            <div class="desc">
                                <p>由人民保险公司承保</p>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="row-a1">
                <div class="g-t1">
                    <h3 class="tit">本站运贸平台</h3>
                </div>
                <ul class="ul-list2">
                    <li>
                        <div class="con">
                            <div class="top">
                                <div class="pic">
                                    <img v-lazy="imgUrl.pcbendihuozhu" alt="">
                                </div>
                            </div>
                            <dl class="dl-list1">
                                <dd v-for="(item,idx) in bzhz_list" :key="idx">
                                    <div class="pic">
                                        <img v-lazy="item.companyLogo" alt="">
                                    </div>
                                    <div class="txt">
                                        <h3 class="tit">{{item.companyName}}</h3>
                                        <div class="add">地址：{{item.address}}</div>
                                        <a  :href="'#/enterpriseStore/info/'+item.companyId" v-if="$root.userComponey!=2&&$root.userComponey!=0" class="homepage">主页 &gt;</a>
                                    </div>
                                </dd>
                            </dl>
                            <div class="more">
                                <a href="#/enterpriseStore/list/huozhu">查看更多 &gt;</a>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="con">
                            <div class="top">
                                <div class="pic">
                                    <img v-lazy="imgUrl.pcbendiwuliu" alt="">
                                </div>
                            </div>
                            <dl class="dl-list1">
                                <dd v-for="(item,idx) in bzwl_list" :key="idx">
                                    <div class="pic">
                                        <img v-lazy="item.companyLogo" alt="">
                                    </div>
                                    <div class="txt">
                                        <h3 class="tit">{{item.companyName}}</h3>
                                        <div class="add">地址：{{item.address}}</div>
                                        <a :href="'#/enterpriseStore/info/'+item.companyId" v-if="$root.userComponey!=2&&$root.userComponey!=0" class="homepage">主页 &gt;</a>
                                    </div>
                                </dd>
                            </dl>
                            <div class="more">
                                <a href="#/enterpriseStore/list/wuliu">查看更多 &gt;</a>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="con">
                            <div class="top">
                                <div class="pic">
                                    <img v-lazy="imgUrl.pcbendiwuliugongxu" alt="">
                                </div>
                            </div>
                            <dl  class="dl-list1">
                                <dd v-for="(item,idx) in wlgx_list" :key="idx">
                                    <div class="pic">
                                        <img v-lazy="item.imgUrls[0]" alt="">
                                    </div>
                                    <div class="txt">
                                        <h3 class="tit">{{item.content}}</h3>
                                        <div class="add">时间：{{item.createdTime}}</div>
                                        <a :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="homepage">主页 &gt;</a>
                                    </div>
                                </dd>
                            </dl>
                            <div  class="more">
                                <a href="#/domesticEmand">查看更多 &gt;</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="row-a2">
                <div class="g-t1">
                    <h3 class="tit">招标公告</h3>
                </div>
                <div class="m-notice">
                    <div class="left">
                        <div class="pic">
                            <img v-lazy="imgUrl.call_bids" alt="">
                        </div>
                        <!-- <h3 class="title"><em>招标信息</em></h3> -->
                    </div>
                    <div class="right">
                        <ul class="ul-tab TAB" id=".ul-list3-1">
                            <li :class="{'on':zb_tab==1}" @click="zb_tab=1">
                                <a href="#/domesticEmand/1" class="more">更多</a>
                                <a href="javascript:;" class="tit">铁路运力供需大厅</a>
                            </li>
                            <li :class="{'on':zb_tab==2}" @click="zb_tab=2">
                                <a href="#/domesticEmand/2" class="more">更多</a>
                                <a href="javascript:;" class="tit">大宗商品采购招标</a>
                            </li>
                        </ul>
                        <ul  class="ul-list3 ul-list3-1" v-if="zb_tab==1">
                            <li v-for="(item,idx) in zbgg_dkf_list" :key="idx">
                                <span class="time">{{item.createdTime}}</span>
                                <a :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="con"><i></i>{{item.content}}</a>
                            </li>
                        </ul>
                        <ul class="ul-list3 ul-list3-1"  v-if="zb_tab==2&&$root.userComponey!=2&&$root.userComponey!=12">
                            <li  v-for="(item,idx) in zbgg_cg_list" :key="idx">
                                <span class="time">{{item.createdTime}}</span>
                                <a :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="con"><i></i>{{item.content}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="m-billboard">
                <a href="#/deliver">
                    <img v-lazy="imgUrl.AD_1" alt="">
                </a>
            </div>
            <div class="row-a3">
                <div class="g-t1">
                    <h3 class="tit">今日大宗货品价格</h3>
                </div>
                <div class="m-goods">
                    <ul class="ul-tab TAB" id=".m-price">
                        <li :class="{'on':sale_tab==1}" @click="sale_tab=1">
                            <a href="#/todaysaleprice" class="more">更多</a>
                            <a href="javascript:;" class="tit">今日售价</a>
                        </li>
                        <li :class="{'on':sale_tab==2}" @click="sale_tab=2">
                            <a href="#/todayacquisitionprice" class="more">更多</a>
                            <a href="javascript:;" class="tit">今日收购价</a>
                        </li>
                    </ul>
                    <dl class="m-price" v-if="sale_tab==1">
                        <dt>
                            <span class="s1">品名</span>
                            <span class="s2">今日价格</span>
                            <span class="s3">单位</span>
                            <span class="s4">区域</span>
                            <span class="s5">发布日期</span>
                            <span class="s6">详细</span>
                        </dt>
                        <dd v-for="(item,idx) in today_sale_list" :key="idx">
                            <span class="s1">{{item.productName}}</span>
                            <span class="s2">￥{{item.productPrice}}</span>
                            <span class="s3">{{item.unitName}}</span>
                            <span class="s4">{{item.placeOfOrigin}}</span>
                            <span class="s5">{{item.releaseTime}}</span>
                            <span class="s6"><a :href="'#/todaysaleprice/info/'+item.releaseProductId">查看</a></span>
                        </dd>
                    </dl>
                    <dl class="m-price" v-if="sale_tab==2">
                        <dt>
                            <span class="s1">品名</span>
                            <span class="s2">今日价格</span>
                            <span class="s3">单位</span>
                            <span class="s4">区域</span>
                            <span class="s5">发布日期</span>
                            <span class="s6">详细</span>
                        </dt>
                        <dd v-for="(item,idx) in today_acquisition_list" :key="idx">
                            <span class="s1">{{item.productName}}</span>
                            <span class="s2">￥{{item.productPrice}}</span>
                            <span class="s3">{{item.unitName}}</span>
                            <span class="s4">{{item.shipAddressTown}}</span>
                            <span class="s5">{{item.releaseTime}}</span>
                            <span class="s6"><a  :href="'#/todayacquisitionprice/info/'+item.releaseProductId">查看</a></span>
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="row-a4" style="padding-left: 20px; padding-right: 20px;" >
                <div class="g-t1">
                    <a href="#/salevideos" class="more">更多</a>
                    <h3 class="tit">视频销售</h3>
                </div>
                <ul class="ul-list4">
                    <li v-for="(v,vdx) in video_list" :key="vdx">
                        <div class="con">
                            <a :href="'#/salevideoinfo/'+v.marketingVideoId"> <div class="video">
                                <img v-lazy="v.coverFile" alt="">
                                <em class="play"></em>
                            </div>
                            </a>
                            <div class="txt">
                                <h3 class="tit">{{v.videoProfile}}</h3>
                                <div class="info">
                                    <div class="fab" :class="{'fabed':v.isLike==1}" @click="handleFav(v)">{{v.likeNumber}}</div>
                                    <a :href="'#/enterpriseStore/info/' + v.companyId" class="name">
                                        <div class="icon">
                                            <img v-lazy="v.companyLogo" alt="">
                                        </div>
                                        <p class="p">{{v.companyName}}</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
            <div class="m-billboard">
                <a href="#/insurance">
                    <img v-lazy="imgUrl.AD_2" alt="">
                </a>
            </div>
            <div class="row-a5">
                <div class="g-t1">
                    <!-- <a href="#/enterpriseStore" class="more">更多</a> -->
                    <h3 class="tit">国际运贸平台</h3>
                </div>
                <ul class="ul-tab ul-tab-1 TAB" id=".ul-list5-1">
                    <li :class="{'on':ym_tab==7}" @click="ym_tab=7">
                        <a href="#/enterpriseStore/list/gjwl" class="more">更多</a>
                        <a href="javascript:;" class="tit">国际物流企业</a>
                    </li>
                    <li :class="{'on':ym_tab==6}" @click="ym_tab=6">
                        <a href="#/enterpriseStore/list/gjmy" class="more">更多</a>
                        <a href="javascript:;" class="tit">国际贸易企业</a>
                    </li>
                </ul>
                <ul class="ul-list5 ul-list5-1" v-if="ym_tab==7">
                    <li v-for="(item,idx) in gjwl_list" :key="idx">
                        <a v-if="$root.userNum==1&&$root.userComponey!=2" :href="'#/enterpriseStore/info/'+item.companyId" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                        <a v-if="$root.userNum!=1||$root.userComponey==2" href="###" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">1地址：{{item.address}}</div>
                            </div>
                        </a>
                    </li>
                </ul>
                <ul class="ul-list5 ul-list5-1" v-if="ym_tab==6">
                    <li v-for="(item,idx) in maoy_list" :key="idx">
                        <a v-if="$root.userNum==1&&$root.userComponey!=2" :href="'#/enterpriseStore/info/'+item.companyId" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                        <a v-if="$root.userNum!=1||$root.userComponey==2" href="###" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                    </li>
                </ul>
            </div>
            <div class="row-a6" style="padding-left: 20px; padding-right: 20px;">
                <ul class="ul-tab ul-tab-1 TAB" id=".ul-list3-2">
                    <li :class="{'on':demand_tab==3}" @click="demand_tab=3">
                        <a href="javascript:;" class="tit">中亚物流需求</a>
                    </li>
                    <li :class="{'on':demand_tab==5}" @click="demand_tab=5">
                        <a href="javascript:;" class="tit">中欧物流需求</a>
                    </li>
                    <li :class="{'on':demand_tab==4}" @click="demand_tab=4">
                        <a href="javascript:;" class="tit">中俄物流需求</a>
                    </li>
                </ul>
                <div class="m-notice m-notice-1">
                    <div class="left">
                        <div class="pic">
                            <img v-lazy="imgUrl.In_demand" alt="">
                        </div>

                    </div>
                    <div v-if="$root.userNum==1&&$root.userComponey!=2&&$root.userComponey!=2" class="right">
                        <ul class="ul-list3 ul-list3-2" v-if="demand_tab==3">
                            <li v-for="(item,idx) in demand_zy_list" :key="idx">
                                <span class="time">{{item.createdTime}}</span>
                                <a  :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="con"><i></i>{{item.content}}</a>
                            </li>
                        </ul>
                        <ul class="ul-list3 ul-list3-2" v-if="demand_tab==5">
                            <li v-for="(item,idx) in demand_zo_list" :key="idx">
                                <span class="time">{{item.createdTime}}</span>
                                <a  :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="con"><i></i>{{item.content}}</a>
                            </li>
                        </ul>
                        <ul class="ul-list3 ul-list3-2" v-if="demand_tab==4">
                            <li v-for="(item,idx) in demand_ze_list" :key="idx">
                                <span class="time">{{item.createdTime}}</span>
                                <a  :href="'#/demand/info/'+item.logisticsSupplyDemandId" class="con"><i></i>{{item.content}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row-a9">
                <div class="g-t1">
                    <h3 class="tit">物流装备/包装类企业门店</h3>
                </div>
                <ul class="ul-tab TAB" id=".ul-list5-2">
                    <li :class="{'on':wlbz_tab==1}" @click="wlbz_tab=1">
                      <a href="#/enterpriseStore/list/ldp11" class="more">更多</a>
                        <a href="javascript:;" class="tit">自备车出租/出售</a>
                    </li>
                    <li :class="{'on':wlbz_tab==2}" @click="wlbz_tab=2">
                      <a href="#/enterpriseStore/list/zbx" class="more">更多</a>
                        <a href="javascript:;" class="tit">集装箱出租/出售</a>
                    </li>
                    <li :class="{'on':wlbz_tab==3}" @click="wlbz_tab=3">
                      <a href="#/enterpriseStore/list/wuliuzb" class="more">更多</a>
                        <a href="javascript:;" class="tit">机械包装企业门店</a>
                    </li>
                </ul>
                <ul class="ul-list5 ul-list5-2" v-if="wlbz_tab==1">
                    <li v-for="(item,idx) in zbcar_list" :key="idx">
                        <a v-if="$root.userNum==1&&$root.userComponey!=2" :href="'#/enterpriseStore/info/'+item.companyId" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                        <a v-if="$root.userNum!=1||$root.userComponey==2" href="###" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                    </li>
                </ul>
                <ul class="ul-list5 ul-list5-2" v-if="wlbz_tab==2">
                    <li v-for="(item,idx) in zbx_list" :key="idx">
                        <a v-if="$root.userNum==1&&$root.userComponey!=2" :href="'#/enterpriseStore/info/'+item.companyId" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                        <a v-if="$root.userNum!=1||$root.userComponey==2" href="###" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>

                    </li>
                </ul>
                <ul class="ul-list5 ul-list5-2" v-if="wlbz_tab==3">
                    <li v-for="(item,idx) in wlzb_list" :key="idx">
                        <a v-if="$root.userNum==1&&$root.userComponey!=2" :href="'#/enterpriseStore/info/'+item.companyId" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>
                        <a v-if="$root.userNum!=1||$root.userComponey==2" href="###" class="con">
                            <div class="pic">
                                <img v-lazy="item.companyLogo" alt="">
                            </div>
                            <div class="txt">
                                <h3 class="tit">{{item.companyName}}</h3>
                                <div class="add">地址：{{item.address}}</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <Footer/>

    <!-- <div class="base"  > -->
    <div class="base"  v-show="showAdv">
        <img class="imggs" v-lazy="imgUrl.login1_image" />
        <div  class="base_div">
            <div class="base_img">
                <img @click="showAdv=false" src="../assets/images/e720feff9178bf93317f560e7bfbb68.png" alt="">
            </div>
            <!-- <div class="base_images">
                <img src="../assets/images/ma-app.png" alt="">
            </div> -->
            <div class="base_btn">
                <a href="#/register">注册 / 入驻</a>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import {storeList,homTopView,getDemands,marketVideos,todaySales,todayAcquisitions,getWlgxList,collectVideo} from '@/services/index'
import {getEnterpriseInfo} from '@/services/qiye'
import Header from "@/components/header";
import Footer from "@/components/footer";

import {Carousel,CarouselItem} from 'element-ui'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  data() {
    return {
        componey:'',
        zb_tab:1,
        wlbz_tab:1,
        sale_tab:1,
        whp_tab:1,
        ldp_tab:1,
        showAdv:true,
        isSettlementAudit:false,
        showHelp:false,
        banners:[],
        bzhz_list:[],
        bzwl_list:[],
        wlgx_list:[],
        imgUrl:{},
        demand_tab:3,
        demand_zy_list:[],
        demand_zo_list:[],
        demand_ze_list:[],
        gjwl_list:[],
        maoy_list:[],
        video_list:[],
        today_sale_list:[],
        today_acquisition_list:[],
        demand_whp_list:[],
        demand_ldp_list:[],
        whphz_list:[],
        whpwl_list:[],
        zbcar_list:[],
        zbx_list:[],
        wlzb_list:[],
        ldphz_list:[],
        zbgg_dkf_list:[],
        zbgg_cg_list:[],
        ym_tab:7,
        defaultStand:{},
        standId:'',
        bureauId:'',
    };
  },
  components: { Header, Footer,VueSlickCarousel,Carousel,CarouselItem  },
  methods: {
      handleFav(item){
          let that=this;
          collectVideo({marketingVideoId:item.marketingVideoId}).then(res=>{
              if(res){
                  item.likeNumber=res.result;
                  item.isLike=item.isLike==1?0:1;
                  that.$message.success('操作成功')
              }
          })
      },
      handleRefresh(status){
          if(status){
              this.showAdv=false;
          }
      },
      refreshByStandId(_standId){
        console.log(_standId)
          this.standId=_standId;
          this.queryympt();
      },
      queryympt(){
        let that=this;
        let _standId=that.standId;
        let _bureauId=that.bureauId;
        storeList({pageNum:1,pageSize:4,auditStatus:1,isShipper:0,standId:_standId}).then(res=>{
            that.bzhz_list=res.result.list;
            console.log(that.bzhz_list)
        })
        storeList({pageNum:1,pageSize:4,auditStatus:1,isShipper:1,standId:_standId}).then(res=>{
            that.bzwl_list=res.result.list;
        })
        getWlgxList({pageNum:1,pageSize:4,releaseType:0,standId:_standId,bureauId:_bureauId}).then(res=>{
            that.wlgx_list=res.result.list;
        })
      }
  },
  mounted(){
    let that=this;
    homTopView().then(f=>{
      console.log(f,'000000000');
      this.$root.juzhan=f.result.defStandDto;
      console.log(this.$root.juzhan)
        let _d=f.result;
        that.banners=_d.bannerListDtos;
        that.imgUrl=_d.imgUrl;
        that.defaultStand=_d.defStandDto;

        let _standId=_d.defStandDto.standId;
        let _bureauId=_d.defStandDto.bureauId;
        that.standId=_standId;
        that.bureauId=_bureauId;
        this.queryympt();

        getWlgxList({pageNum:1,pageSize:4,releaseType:1,bureauId :_bureauId}).then(res=>{
            that.zbgg_dkf_list=res.result.list;
            console.log(res.result.list,'大客户')
        })

        getWlgxList({pageNum:1,pageSize:4,releaseType:2.,bureauId :_bureauId}).then(res=>{
            that.zbgg_cg_list=res.result.list;
            console.log(res.result.list,'装车')
        })

        //今日大宗货品价格
        todaySales({pageNum:1,productStatus:0,releaseSource:1,
              pageSize:6}).then(res=>{
            that.today_sale_list=res.result.list;
        })
        todayAcquisitions({
            pageNum:1,pageSize:10,productStatus:0,
        }).then(res=>{
            that.today_acquisition_list=res.result.list;
        })

        //视频销售
        marketVideos({pageNum:1,type:1,
              pageSize:5}).then(res=>{
            that.video_list=res.result.list;
        })

        //危化品货主/物流门店
        storeList({pageNum:1,
            pageSize:4,
            identityId:8,
            isShipper:0}).then(res=>{
                that.whphz_list=res.result.list;
        })
        storeList({pageNum:1,
            pageSize:4,
            identityId:13,
            isShipper:1}).then(res=>{
                that.whpwl_list=res.result.list;
        })

        //冷冻品货主/物流门店
        storeList({pageNum:1,
              pageSize:4,
              identityId:11,
              isShipper:0}).then(res=>{
                that.ldphz_list=res.result.list;
        })
        storeList({pageNum:1,
              pageSize:4,
              identityId:14,
              isShipper:1}).then(res=>{
                that.ldpwl_list=res.result.list;
        })

        //物流装备/包装类企业门店
        storeList({pageNum:1,
            pageSize:4,
            identityId:9}).then(res=>{
            that.zbcar_list=res.result.list;
        })
        storeList({pageNum:1,
            pageSize:4,
            identityId:10}).then(res=>{
                that.zbx_list=res.result.list;
        })

        //运贸平台
        //国际物流企业
        storeList({pageNum:1,
            pageSize:4,
            identityId:7}).then(res=>{
                that.gjwl_list=res.result.list;
        })
        //国际贸易企业
        storeList({pageNum:1,
            pageSize:4,
            identityId:6}).then(res=>{
                that.maoy_list=res.result.list;
        })

        //国际需求
        //中亚
        getDemands({ pageNum:1,
              pageSize:8,
              releaseType:3}).then(res=>{
            that.demand_zy_list=res.result.list;
        })
        //中欧
        getDemands({ pageNum:1,
              pageSize:8,
              releaseType:5}).then(res=>{
            that.demand_zo_list=res.result.list;
        })
        //中俄
        getDemands({ pageNum:1,
              pageSize:8,
              releaseType:4}).then(res=>{
            that.demand_ze_list=res.result.list;
        })

        // //危化品采购与物流需求
        // getDemands({ pageNum:1,
        //       pageSize:8,
        //       releaseType:67}).then(res=>{
        //     that.demand_whp_list=res.result.list;
        // })

        // //冷冻品采购与物流需求
        // getDemands({ pageNum:1,
        //       pageSize:8,
        //       releaseType:89}).then(res=>{
        //     that.demand_ldp_list=res.result.list;
        // })

        //机械车辆包装/托盘
        storeList({pageNum:1,
            pageSize:4,auditStatus:1,
            identityId:12}).then(res=>{
                that.wlzb_list=res.result.list;
        })
    })
  }
};
</script>

<style>
@import url("../style/index.css");

/* .main{
    background:#fff;
} */
.base{
    /* background: #060c25; */
    min-width: 1200px;

    overflow: auto;
    background: linear-gradient(90deg, #070d28, #060c25) ;
    /* background: linear-gradient(90deg, #070d28, #060c25) url(../assets/image) ; */
}
.base_btn{
    position: absolute;
    bottom: 50px;
    right: 350px;
    display: block;
    text-align: right;
}
.base_btn a{
    border-radius: 5px;
    width: 140px;
}
.base_div{
    width: 1200px;
    position: relative;
    height: 100%;
}
.banner{
    position: relative;
}
.ul-list4,.ul-list4 .con,.ul-list4 .fab{
    overflow:inherit !important;
}
.ul-list4 .txt{
    margin-bottom:10px;
}
.ul-list4 .info{
    overflow: inherit !important;
}
.ul-list4 .name{
    overflow:initial !important;
}

.ul-tab li {
    margin-top: -16px;
}
.dl-list1{
  height: 388px;
}
.dl-list1 dd{
  display: flex;
  align-items: center;
}
.dl-list1 .txt{
  width: 260px;
}
.ul-list1 .tit{
  font-size: 13px;
}
.fabed{
    background-image:url('../assets/images/hongxin.png') !important;
    background-size:50% !important;
}

.ul-list5 .tit,.ul-list5 .add, .dl-list1 .tit{
  font-size: 13px!important;
}
.dl-list1 .add {
  font-size: 13px!important;
}
.dl-list1 .homepage {
    font-size: 13px!important;
}
.ul-list4 .txt{
  height: 70px;
  box-sizing: border-box;
}
.ul-list4 .tit{
  height: 18px;
  font-size: 13px;
  margin-bottom: 6px;
}
.m-price span{
  font-size: 13px;
}
.ul-list4 .name .p{
  font-size: 13px;
}
.m-price dd span{
  font-weight: 500;
}
.ul-tab .tit{
  font-size: 14px;
}
.g-t1 .tit{
  font-weight: 600;
  font-size: 16px;
}
.banner .el-carousel__container {
    height: 500px!important;
}
.imggs{
  position: absolute;
  left: 50%;
  transform: translate(-50%,-50%);
  top: 50%;
  width: 900px;
  /* height: 100%; */
  z-index: -1;
  max-width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue